import { jsx as _jsx } from "react/jsx-runtime";
const IndexTableRowCellSlot = ({
  children
}) => {
  if (children) {
    return /*#__PURE__*/_jsx("td", {
      children: children
    });
  }
  return /*#__PURE__*/_jsx("td", {});
};
export default IndexTableRowCellSlot;